module.exports = __webpack_public_path__ + "static/media/office_icon.7878e1da.svg";